import { createContext, FC, useState, useEffect } from 'react';
import {
  SalesCountdownDataI,
  SalesCountdownProviderT,
} from '@providers/SalesCountdownProvider/types';

export const SalesCountdownContext = createContext<any>({
  CTA: {},
  description: '',
  display: true,
  offerEndsAt: '',
  displayOnPage: true,
});

export const SalesCountdownProvider: FC<SalesCountdownProviderT> = ({
  children,
  salesCountdownData,
}) => {
  const [persistentOfferEndsAt, setPersistentOfferEndsAt] = useState<string | null>(null);

  useEffect(() => {
    if (!persistentOfferEndsAt && salesCountdownData?.offerEndsAt) {
      setPersistentOfferEndsAt(salesCountdownData.offerEndsAt);
    }
  }, [salesCountdownData?.offerEndsAt, persistentOfferEndsAt]);

  const data: SalesCountdownDataI = {
    CTA: salesCountdownData?.CTA,
    description: salesCountdownData?.description,
    display: salesCountdownData?.display || false,
    offerEndsAt: persistentOfferEndsAt || salesCountdownData?.offerEndsAt,
    displayOnPage: salesCountdownData?.displayOnPage || false,
  };

  return <SalesCountdownContext.Provider value={data}>{children}</SalesCountdownContext.Provider>;
};
